import { render, staticRenderFns } from "./SelectedPartner.vue?vue&type=template&id=74e49876&scoped=true"
import script from "./SelectedPartner.vue?vue&type=script&lang=js"
export * from "./SelectedPartner.vue?vue&type=script&lang=js"
import style0 from "./SelectedPartner.vue?vue&type=style&index=0&id=74e49876&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e49876",
  null
  
)

export default component.exports